export default [
  { _id: 1, name: "Leadership role" },
  { _id: 2, name: "Team member role" },
];
